import { GuardResult, MaybeAsync, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@flexyoo/auth';
import { RoleEnum } from '../../shared/models/general/general-enum';
import { appRoutesPerRoleDefaults } from '../../app-routes-per-role-defaults.constant';
import { map } from 'rxjs';
import { EmployeeSettingsService } from '@flexyoo/employee/data-access';

@Injectable()
export class HRGuard {
  constructor(
    protected readonly router: Router,
    private readonly auth: AuthenticationService,
    private readonly employeeSettingsService: EmployeeSettingsService
  ) {}

  canMatch(): MaybeAsync<GuardResult> {
    const user = this.auth.getCurrentUser();

    if (!user) {
      this.auth.logout();
      return false;
    }

    if (user.Role === RoleEnum.HR) {
      return this.employeeSettingsService.updateAndLoadTenantSettings(user.Id).pipe(
        map(({ userSettings, tenantSettings }) => {
          if ((userSettings?.isActive && tenantSettings?.isActive) || user.Impersonated) {
            return true;
          }

          this.auth.logout();
          return false;
        })
      );
    }

    if (user.Role === RoleEnum.Employee) {
      this.auth.navigateToEmployeeDefaultRoute();
      return false;
    }

    if ([RoleEnum.Admin, RoleEnum.Opco].includes(user.Role as RoleEnum)) {
      return this.router.navigateByUrl(appRoutesPerRoleDefaults[user.Role]);
    }

    this.auth.logout();
    return false;
  }
}
